export default "__VITE_ASSET__BvlkzhdH__"